module.exports = __webpack_public_path__ + "static/media/Villas-at-Northville-Rules-Guidelines-.767eb860.pdf";